import { render, staticRenderFns } from "./ClientsSayCard.vue?vue&type=template&id=f6c3c65c&scoped=true&"
import script from "./ClientsSayCard.vue?vue&type=script&lang=js&"
export * from "./ClientsSayCard.vue?vue&type=script&lang=js&"
import style0 from "./ClientsSayCard.vue?vue&type=style&index=0&id=f6c3c65c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c3c65c",
  null
  
)

export default component.exports